import { HamletClient, IHamletClient } from '@atlassiansox/asc-hamlet';
import { createContext } from 'react';

export const HamletClientContext = createContext<IHamletClient>(
  new HamletClient()
);
